export default __webpack_public_path__ + "static/media/ImageryFirefly.86e8ad7f.png";